<div [style]="styleObj" id="video-list-container" >
    <div [style.width]="width" *ngFor="let video of videos">
        <app-video
        [video] = video 
        ></app-video>
    </div>
</div>
